import { showToast } from "@/lib/toasts";

// The API rejects SVG uploads with a 422 (emails/models/image/routes.py). A
// file-input `accept` filter only covers the picker dialog — drag-and-drop and
// paste bypass it — so those paths must guard explicitly. Returns true (and
// surfaces a toast) when the file is an SVG that should not be uploaded.
export const rejectSvgUpload = (file: File): boolean => {
  if (file.type === "image/svg+xml" || file.name.endsWith(".svg")) {
    showToast({
      type: "error",
      title: "SVG files are not supported",
      message: "Please upload a PNG, JPG, or GIF instead.",
    });
    return true;
  }
  return false;
};

export const convertUrl = (url: string, mode: "full" | "optimized"): string => {
  // Remove the params.
  const pathWithoutQueryParams = url.split("?")[0];
  if (mode === "full") {
    return pathWithoutQueryParams;
  }
  return `${pathWithoutQueryParams}?w=960&fit=max`;
};
